import React from 'react';

const ActivityFeed = ({ activities, loading }) => {
    if (loading) {
        return (
            <div className="bg-gray-800 rounded-lg border border-gray-700 shadow-lg overflow-hidden h-96 animate-pulse">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700 h-10"></div>
            </div>
        );
    }

    return (
        <div className="bg-gray-800 rounded-lg border border-gray-700 shadow-lg overflow-hidden flex flex-col h-full">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex-shrink-0">
                <h2 className="text-green-400 font-bold uppercase tracking-wider flex items-center gap-2 text-sm sm:text-base">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                    Live Activity
                </h2>
            </div>
            <div className="flex-1 overflow-y-auto p-4 space-y-4 font-mono text-xs">
                {activities.length > 0 ? (
                    activities.map((log) => (
                        <div key={log.id} className="border-l-2 border-gray-700 pl-3 py-1 group hover:border-green-500 transition-colors">
                            <div className="text-green-500 font-bold mb-0.5">
                                {new Date(log.created_at).toLocaleTimeString()}
                            </div>
                            <div className="text-gray-300">
                                <span className="text-blue-400">[{log.performed_by || 'System'}]</span> {log.summary || log.event_type}
                            </div>
                            {log.entity && (
                                <div className="text-gray-500 mt-0.5">
                                    Target: {log.entity} #{log.entity_id?.slice(0, 8)}
                                </div>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="text-center text-gray-500 py-8">
                        No recent activity logs.
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActivityFeed;
